export var isTokensResponse = function (result) {
    return result.AuthenticationResult !== undefined;
};
export var Servers;
(function (Servers) {
    Servers["europe"] = "EU";
    Servers["america"] = "US";
})(Servers || (Servers = {}));
